module.exports = __webpack_public_path__ + "img/bild2.ad67f040.jpg";